import PieBase from './PieBase';
import GaugeBase from './GaugeBase';
import { useTheme } from '@mui/material/styles';

const EDIT_STATUS = 'edit-alert-status';
const CLOSED_OUT = 'Closed-Out';

// These are grouped together
// because seen is a closeout reason.

export default function CloseoutReasonChart({ chartData }) {
  const { palette } = useTheme();

  const data = [];
  const reasonCounts = {};

  for (const {
    actionHistory: { actions },
  } of chartData) {
    for (const {
      action,
      altered: { to, reason },
    } of actions) {
      if (action === EDIT_STATUS && to === CLOSED_OUT) {
        if (!(reason in reasonCounts)) {
          reasonCounts[reason] = {
            label: reason,
            value: 1,
          };
        } else {
          reasonCounts[reason].value += 1;
        }
      }
    }
  }

  for (const reason of Object.values(reasonCounts)) {
    data.push(reason);
  }

  return (
    <>
      <GaugeBase
        title='Seen'
        value={data.find((reason) => reason.label === 'Seen')?.value ?? 0}
        max={chartData.length}
        color={palette.success.main}
      />
      <PieBase
        title='Close-Out Reasons'
        data={data}
      />
    </>
  );
}
